import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import type { QuestionnaireGenre } from '@/models/onboarding.types'

const delayMultiplier = 0.1


export default /*@__PURE__*/_defineComponent({
  __name: 'GenreSelectionOption',
  props: {
    option: {},
    isSelected: { type: Boolean },
    index: {}
  },
  setup(__props: any) {



const optionsHTML = {
  business:
    '<path d="M201.044 154.902c-1.779-2.551-.094-6.068 3.009-6.279l163.482-11.142c3.103-.212 5.25 3.043 3.833 5.812l-14.869 29.065a3.999 3.999 0 0 0 .28 4.11l18.675 26.778c1.78 2.551.094 6.067-3.008 6.279l-163.483 11.142c-3.103.211-5.25-3.044-3.833-5.813l14.869-29.064a3.999 3.999 0 0 0-.28-4.11l-18.675-26.778Z"/><text transform="rotate(-3.851 2617.147 -3719.678)" xml:space="preserve"><tspan x="-3" y="18.02">Business</tspan></text>',
  communication:
    '<path d="M192.554 74.448c18.05 5.175 28.487 24.004 23.311 42.054-5.175 18.05-24.004 28.487-42.054 23.311a2.547 2.547 0 0 0-3.15 1.747l-2.523 8.798c-.421 1.468-2.266 1.942-3.342.859l-18.689-18.819a3.991 3.991 0 0 0-1.736-1.026l-85.912-24.635c-18.05-5.176-28.487-24.004-23.31-42.055 5.175-18.05 24.003-28.487 42.054-23.311l115.351 33.077Z"/><text transform="rotate(16 -183.412 285.682)" xml:space="preserve"><tspan x="-6" y="18.02">Communication</tspan></text>',
  health:
    '<path d="M357.241 248.231c2.185.32 3.71 2.355 3.257 4.517a65.028 65.028 0 0 1-7.798 19.958 65.03 65.03 0 0 1-16.996 18.825 65.016 65.016 0 0 1-22.906 10.887c-2.476.625-3.467 7.448-1.272 8.752a64.999 64.999 0 0 1 31.58 61.326c-.185 2.202-2.23 3.715-4.415 3.395l-120.714-17.67c-2.186-.32-3.711-2.355-3.257-4.517a65 65 0 0 1 47.566-49.636c2.495-.635 3.498-7.537 1.288-8.856a64.995 64.995 0 0 1-31.462-61.256c.185-2.202 2.229-3.714 4.415-3.394l120.714 17.669Z"/><text transform="rotate(8.328 -1625.798 1763.426)" xml:space="preserve"><tspan x="30" y="18.4">Health</tspan><tspan x="49" y="46.4">&</tspan><tspan x="20" y="74.4">Wellness</tspan></text>',
  leadership:
    '<path d="m53.43 305.758 88.472 67.086 77.339-79.663-42.056-34.13-87.327 6.624-36.427 40.083Z"/><text transform="rotate(-4.338 3894.09 -1081.743)" xml:space="preserve"><tspan x="-1" y="18.02">Leadership</tspan></text>',
  productivity:
    '<path clip-rule="evenodd" d="m142.328 230.329 56.043-21.513c-17.769-46.291-69.379-69.536-115.273-51.919-45.894 17.617-68.693 69.425-50.924 115.716L88.218 251.1c-5.786-15.072 1.637-31.939 16.579-37.675 14.943-5.736 31.746 1.832 37.531 16.904Z"fill-rule="evenodd"/><circle cx="111.831" cy="231.778" r="9.329" transform="rotate(-21 111.831 231.778)"/><text transform="rotate(-21 548.467 -38.425)" xml:space="preserve"><tspan x="-3" y="18.02">Productivity</tspan></text>',
  relationships:
    '<path d="M280.276 130.281c17.901-5.432 44.203-14.564 57.467-24.696 9.919-7.566 16.428-19.044 17.813-31.414 3.546-28.036-25.161-50.468-51.758-40.495-1.494.554-2.936 1.246-4.417 1.957-.604.29-1.215.583-1.839.871a137.4 137.4 0 0 1-.848-1.849c-.678-1.496-1.338-2.954-2.126-4.339-13.964-24.735-50.374-26.004-65.679-2.248-6.89 10.367-9.282 23.343-6.546 35.514 3.647 16.288 17.926 40.19 28.147 55.858 2.847 4.366 11.035 16.02 11.035 16.02s13.763-3.664 18.751-5.179Z"/><text transform="rotate(20 12.824 710.191)" xml:space="preserve"><tspan x="-3" y="18.02">Relationships</tspan></text>',
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("g", {
    class: _normalizeClass(["genre-option", { 'genre-option--selected': __props.isSelected }]),
    style: _normalizeStyle({
      '--genre-color': __props.option.color,
      '--genre-popup-delay': `${__props.index * delayMultiplier}s`,
    }),
    innerHTML: optionsHTML[__props.option.id]
  }, null, 14, _hoisted_1))
}
}

})